import { globalEmitter } from '../helpers/emitter'
import { type_WISHLIST_DASHBOARD_STATE } from '../types'
import { FormValidate } from './FormValidate'
import { Modal } from './Modal'
import { TextInput } from './TextInput'
import { SelectInput } from './SelectInput'
import { closeModal } from '../helpers/useModal'
import { OmneoListItem as ConstructedOmneoListItem } from '../helpers/omneo.service'

declare var wishlistDashboardState: type_WISHLIST_DASHBOARD_STATE

export function WishlistCreateList() {
  return <Modal id="create-list-slideout" className="modal-wishlist" content={<RenderContent />} type="slideout" />
}

function RenderContent() {
  const listPrivacy = [
    {
      name: 'Private',
      value: 'private'
    },
    {
      name: 'Public',
      value: 'public'
    }
  ]

  const handleSubmitForm = async (formEl: HTMLFormElement | null) => {
    if (!formEl) return

    const formData = new FormData(formEl)
    const name = formData.get('name')
    const privacy = formData.get('privacy')
    if (!name) return

    const isShared = privacy === 'public'
    const wishlistName = name.toString().toLowerCase().trim()

    let initialItem: ConstructedOmneoListItem | null = null
    getInitialItem: try {
      const parentModalContext = formEl.closest('#create-list-slideout')?.getAttribute('data-context')
      if (!parentModalContext) break getInitialItem
      const jsonContext = JSON.parse(parentModalContext)
      if (!jsonContext?.item) break getInitialItem

      initialItem = jsonContext.item
    } catch (err) {
      console.error('Could not parse initialItem context', err, formEl, formEl.closest('#create-list-slideout'))
    }

    const result = await window.omneoService.createList(wishlistName, initialItem)
    
    if (result && isShared) {
      await window.omneoService.shareWishlist(result.id)
    }

    if (result?.name) {
      globalEmitter.emit('triggerNotification', { message: 'List created successfully', type: 'success' })
    } else {
      globalEmitter.emit('triggerNotification', { message: 'Could not create new list', type: 'error' })
    }
    globalEmitter.emit('createNewList')
    closeModal('create-list-slideout')
    if (result?.name && initialItem) {
      closeModal('wishlist-slideout')
    }
    formEl.reset()
  }

  const submitForm = (formEl: HTMLFormElement | null) => {
    handleSubmitForm(formEl).then()
  }

  return (
    <div className="w-full">
      <h3 className="text-xl mb-[30px] font-sans font-light tracking-normal uppercase text-center text-ink md:text-3xl md:mb-[45px]">{wishlistDashboardState.newList.title}</h3>
      <FormValidate id={'wishlist-create'} submitForm={submitForm}>
        <TextInput
          id="wishlist_name"
          type="text"
          label={wishlistDashboardState.newList.name}
          name="name"
          placeholder={wishlistDashboardState.newList.name}
          required={true}
        />
        <SelectInput
          id="wishlist_privacy"
          label={wishlistDashboardState.privacy.privacy}
          name="privacy"
          value="private"
          items={listPrivacy}
        />
        <p className="text-xs text-ink font-light font-calibre mt-5 mb-0 md-max:mt-[15px]">{wishlistDashboardState.newList.description}</p>
        <button className="Button Button--tertiary Button--full w-full mt-[30px] md:mt-[45px]">{wishlistDashboardState.newList.create}</button>
      </FormValidate>
    </div>
  )
}
